<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
          <p>Transcribir</p>
          <p>ChatGPT para</p>
          <p>Traducir</p>
          <p>Añadir subtítulos a</p>
        </div>
        <span id="text1"></span>tu vídeo.</template>
      <template slot="landing_description">Crea automáticamente transcripciones, traducciones, subtítulos y analiza tus vídeos en más de 40 idiomas.</template>

      <template slot="intro_video">
    
          <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
      </template>

      <template slot="start_your_trial">PRUEBA TAPTION</template>

      <template slot="use_case_title">Características del producto.</template>
      <template slot="youtubers">Convertir vídeo a texto</template>
      <template slot="youtubers_question">Transcribe tus vídeos y genera automáticamente subtítulos y leyendas</template>


      <template slot="journalists">Análisis con IA</template>
      <template slot="journalists_question">Resume vídeos, genera temas y crea capítulos para YouTube. Ten tu propio ChatGPT personalizado</template>
     
      <template slot="translators">Traducir vídeo</template>
      <template slot="translators_question">Traduce tus subtítulos y transcripciones a más de 50 idiomas</template>

      <template slot="speaker">Etiquetado de hablantes</template>
      <template slot="speaker_question">Convierte audio a texto y etiqueta a los hablantes en tus grabaciones</template>

      <template slot="audiotomp4">Convierte tu audio a vídeo</template>
      <template slot="audiotomp4_question">Toma tu archivo de audio y una imagen para convertirlos en un vídeo MP4 con subtítulos</template>

      <template slot="importsrt">Convertir TXT a SRT</template>
      <template slot="importsrt_question">Añade marcas de tiempo al texto y formatea automáticamente.</template>

      <template slot="share">Colabora con equipos</template>
      <template slot="share_question">Comparte cuentas y personaliza funciones con gestión de permisos de usuario</template>

      <template slot="learnmore">Saber más</template>
      

      <template slot="simple_workflow">Flujo de trabajo sencillo.</template>
      <template slot="upload">Subir</template>
      <template slot="upload_description">Sube tu vídeo a nuestra plataforma o usa nuestro generador de transcripciones de YouTube para transcribir directamente desde YouTube. También puedes subir archivos desde Zoom, Webex y Google Drive.</template>
      <template slot="edit_translate">Editar</template>
      <template slot="edit_translate_description">Edita tu transcripción sin preocuparte por ajustar las marcas de tiempo. Además, nuestro editor de vídeo en línea te permite editar tu vídeo directamente en la plataforma.</template>
      <template slot="transcribe">Análisis con IA</template>
      <template slot="transcribe_description">Haz cualquier pregunta para consultar el contenido del vídeo. Ofrecemos plantillas comunes, como crear capítulos de YouTube con marcas de tiempo, resumir vídeos, generar resúmenes para YouTube y generadores de temas de vídeo.</template>
      <template slot="translate">Traducir</template>
      <template slot="translate_description">Nuestra traducción en línea admite más de 40 idiomas, destacando especialmente en traducciones entre idiomas de diferentes regiones, como inglés a chino, inglés a japonés, inglés a vietnamita o viceversa.</template>
      <template slot="export">Exportar</template>
      <template slot="export_description">Después de terminar la edición de subtítulos y la edición de vídeo, puedes exportar en MP4 con subtítulos incrustados, SRT, VTT, PDF y archivos TXT.</template>
      <template slot="try_it_now">Pruébalo ahora</template>


      <template slot="editing_platform_desc1">La función de línea de tiempo de Taption simplifica la edición de vídeo. Cuando las ediciones se superponen con los subtítulos, ajusta automáticamente el texto y el tiempo, garantizando precisión y sincronización. Nuestro editor de vídeo en línea es perfecto para ediciones rápidas, creando fácilmente vídeos subtitulados profesionales.</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <button v-show="!videoState.video1" class="play"></button>
                  <video id="video1" ref="video1" playsinline class="unique-video" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
      
      <template slot="editing_platform">Increíble plataforma de edición.</template>
      <template slot="editing_platform_desc0">Además de la edición de subtítulos y transcripciones, nuestra plataforma generadora de subtítulos permite la edición precisa de vídeo directamente a través de los subtítulos. Ajusta automáticamente el tiempo de otros subtítulos para que coincidan con el vídeo editado, asegurando una reproducción fluida y sincronizada.</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" class="intro-video" poster="../assets/images/thumbnail/trim_thumbnail_en_US.webp" :src='"@/assets/video/Trim_English.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>

 
      <template slot="editing_platform_desc2">Nuestra función de análisis con IA mejora la comprensión del vídeo creando resúmenes, identificando puntos clave y permitiendo búsquedas de contenido. Además, ofrece plantillas de uso común, incluyendo la creación de capítulos de YouTube, generación de temas de vídeo y corrección de subtítulos, mejorando el proceso de edición de vídeo.</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">Los memos te permiten añadir notas en momentos específicos de la transcripción del vídeo, creando anotaciones para que otros usuarios las vean. Los usuarios pueden navegar rápidamente a los segmentos de vídeo correspondientes usando estos memos, mejorando el proceso de conversión de vídeo a texto. Esta herramienta es útil para la edición de vídeo, generación de subtítulos y creación de capítulos o resúmenes de YouTube.</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template> 

                   

      <template slot="low_cost">Precios asequibles.</template>
      <template slot="title_basic">Pago por uso</template>
      <template slot="basic_cost_usd">$8</template>
      <template slot="basic_cost_ntd">(240 NTD)</template>
      <template slot="hour">hora</template>
      <template slot="basic_feature5">Crédito de <span style="color: #00d1b2;">60 minutos</span></template>
      <template slot="basic_feature1">Transcripción automatizada</template>
      <template slot="basic_feature2">Más de 40 idiomas compatibles</template>
      <template slot="basic_feature3">Editor de texto resaltado</template>
      <template slot="basic_feature4">Traducción a más de 50 idiomas</template>
      <template slot="basic_feature7">Diccionario AI personal</template>
      <template slot="basic_feature6">Permite uso comercial</template>
      <template slot="basic_feature8">Admite subtítulos incrustados en múltiples idiomas</template>

      <template slot="title_premium">Suscripción Premium</template>
      <template slot="premium_cost_usd">$12</template>
      <template slot="premium_cost_ntd">(360 NTD)</template>
      <template slot="premium_basic_cost_usd">$6</template>
      <template slot="month">mes</template>

      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>Todas las funciones de「Pago por uso」</template>
      <template slot="premium_feature1"><span style="color: #00d1b2;">120 minutos</span> de crédito en tu cuenta cada mes.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Minutos acumulables, válidos hasta la cancelación de la suscripción)</span></template>
      <template slot="premium_feature1_tooltip">Si los minutos mensuales no se consumen, se acumularán para el mes siguiente y serán válidos hasta que se cancele la suscripción. <br>Estos minutos mensuales se utilizan antes que los minutos adicionales comprados por separado. <br>Los minutos adicionales comprados por separado no caducan después de cancelar la suscripción.</template>
      <template slot="premium_feature2">25% de descuento en compras por hora</template>
      <template slot="premium_feature3">Exportaciones ilimitadas de subtítulos incrustados gratis</template>
      <template slot="premium_feature4">Compartir transcripciones editables</template>
      <template slot="premium_feature5">Exporta tus grabaciones de audio a vídeos con subtítulos</template>
      <template slot="premium_feature6">Corte de vídeo (La transcripción/subtítulos exportados se ajustarán automáticamente)</template>

      <template slot="title_corp">Suscripción por volumen</template>
      <template slot="bulk_cost_usd">$69</template>
      <template slot="bulk_cost_ntd">(2070 NTD)</template>
      <template slot="bulk_basic_cost_usd">$4</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>Todas las funciones de「Pago por uso」y「Suscripción Premium」</template>
       <template slot="bulk_feature2">63% de descuento en compras por hora</template>
      <template slot="premium_feature1_bulk"><span style="color: #00d1b2;">1000 minutos</span> de crédito en tu cuenta cada mes.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Minutos acumulables, válidos hasta la cancelación de la suscripción)</span></template>
      <template slot="bulk_feature1">Proporciona descarga de recibos con el nombre de tu institución y NIF</template>

       <template slot="bulk_feature3">Comparte minutos con usuarios</template>
       <template slot="bulk_feature4">6 permisos diferentes configurables</template>

      <template slot="go_to_price">Más detalles</template>
    </LandingPage>
</template>


<script>
import LandingPage from "./LandingPage";
//import Typed from 'typed.js';
export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   

    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }

    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }

    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }


    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           